import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { ViewerAsset } from '@models/viewer-asset';
import { DrawingTools } from '@shared/drawing/drawing';
import { ViewerAudioPlayerComponent } from '@shared/viewer/viewer-audio-player/viewer-audio-player.component';
import { ViewerConfigurationModel } from '@shared/viewer/viewer-configuration-model';
import { ViewerDrawComponent } from '@shared/viewer/viewer-draw/viewer-draw.component';
import {
  ViewerNavigationToggleComponent
} from '@shared/viewer/viewer-navigation-toggle/viewer-navigation-toggle.component';
import { ViewerPrintComponent } from '@shared/viewer/viewer-print/viewer-print.component';
import { ViewerBaseComponent } from '@shared/viewer/viewer-shared/viewer-base.component';
import { ViewerZoomComponent } from '@shared/viewer/viewer-zoom/viewer-zoom.component';
import { ViewerAdditionalInfoComponent } from './viewer-additional-info/viewer-additional-info.component';

@Component({
  selector: 'zbp-viewer-controls',
  templateUrl: './viewer-controls.component.html',
  styleUrls: ['./viewer-controls.component.scss',],
  encapsulation: ViewEncapsulation.None,
  imports: [
    CommonModule,
    ViewerAdditionalInfoComponent,
    ViewerDrawComponent,
    ViewerAudioPlayerComponent,
    ViewerNavigationToggleComponent,
    ViewerZoomComponent,
    ViewerPrintComponent
  ]
})
export class ViewerControlsComponent extends ViewerBaseComponent {
  @Input() viewerConfiguration: ViewerConfigurationModel;
  @Input() viewerAssets: ViewerAsset[] = [];
  @Output() activeTool = new EventEmitter<DrawingTools>();
  @Output() zoomPercent = new EventEmitter<number>();
  @Output() triggerPrint = new EventEmitter<boolean>();

  setActiveDrawingTool(activeDrawingTool: DrawingTools): void {
    this.selectedTool = activeDrawingTool;
    this.activeTool.emit(activeDrawingTool);
  }

  setActiveZoomTool(activeZoomTool: DrawingTools): void {
    this.selectedTool = activeZoomTool;
  }

  setZoomPercent(zoom: number): void {
    this.zoomLevel = zoom;
    this.zoomPercent.emit(zoom);
  }

  printImage(): void {
    this.triggerPrint.emit(true);
  }
}
